export default IconGenderNeutrois => `<svg xmlns="http://www.w3.org/2000/svg" class="icon icon-tabler icon-tabler-gender-neutrois" width="24" height="24" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor" fill="none" stroke-linecap="round" stroke-linejoin="round">
  <path stroke="none" d="M0 0h24v24H0z" fill="none"/>
  <path d="M12 10a5 5 0 1 1 0 10a5 5 0 0 1 0 -10z" />
  <path d="M12 10v-7" />
</svg>`;